import apiSportsClubs from '@/api/sports-clubs'

const state = {
  isLoading: false,
  sportsClubs: [],
  validationErrors: null,
  isSubmitting: false
}

export const mutationTypes = {
  getSportClubsStart: '[sportsClubs] getSportClubsStart',
  getSportClubsSuccess: '[sportsClubs] getSportClubsSuccess',
  getSportClubsFailure: '[sportsClubs] getSportClubsFailure',

  addSportClubsStart: '[sportsClubs] addSportClubsStart',
  addSportClubsSuccess: '[sportsClubs] addSportClubsSuccess',
  addSportClubsFailure: '[sportsClubs] addSportClubsFailure'
}

export const actionType = {
  getSportClubs: '[sportsClubs] getSportClubs',
  addSportClubs: '[sportsClubs] addSportClubs'
}

const mutations = {
  [mutationTypes.getSportClubsStart](state) {
    state.isLoading = true
    state.validationErrors = null
  },

  [mutationTypes.getSportClubsSuccess](state, payload) {
    state.isLoading = false
    state.sportsClubs = payload.map(club => ({
      type: 'club',
      ...club
    }))
  },

  [mutationTypes.getSportClubsFailure](state, payload) {
    state.isLoading = false
    state.validationErrors = payload
  },

  [mutationTypes.addSportClubsStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.addSportClubsSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.getSportClubsFailure](state) {
    state.isSubmitting = false
  }
}

const actions = {
  [actionType.getSportClubs](context) {
    context.commit(mutationTypes.getSportClubsStart)
    return new Promise(resolve => {
      apiSportsClubs
        .getSportClubs()
        .then(response => {
          context.commit(
            mutationTypes.getSportClubsSuccess,
            response.data
          )
          resolve(response.data)
        })
        .catch(result => {
          context.commit(
            mutationTypes.getSportClubsFailure,
            result.response.data.errors
          )
        })
    })
  },

  [actionType.addSportClubs](context, sport) {
    context.commit(mutationTypes.addSportClubsStart)
    return new Promise(resolve => {
      apiSportsClubs
        .addSportClubs(sport)
        .then(response => {
          context.commit(
            mutationTypes.addSportClubsSuccess,
            response.data
          )
          resolve(response.data)
        })
        .catch(result => {
          context.commit(
            mutationTypes.addSportClubsFailure,
            result.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
